<script lang="ts">
  import filtersService from './utils/filters-service.svelte';
  import dataService from './utils/data-service.svelte';
  import Filters from './Filters.svelte';
  import SeminarsList from './SeminarsList.svelte';
  import type { Seminar, Speaker, Business, Theatre, Filters as FiltersT } from './types';
  import { getSeminarDates, getSeminarEarliestLatestTimes } from './utils/helpers';
  import { stickySidebar } from './utils/stickySidebar';

  type Props = {
    seminars: Seminar[];
    speakers: Speaker[];
    businesses: Business[];
    theatres: Theatre[];
    defaultFilters?: FiltersT;
    hideFilters?: string[];
  };

  const { seminars, speakers, businesses, theatres, defaultFilters, hideFilters }: Props = $props();

  const dates = getSeminarDates(seminars);
  const times = getSeminarEarliestLatestTimes(seminars);

  filtersService.init({ seminars, defaultFilters });
  dataService.init({ speakers, businesses, theatres, seminars });
</script>

<div class="flex max-lg:flex-col gap-5">
  <div class="lg:w-[15rem] shrink-0">
    <div {@attach stickySidebar({ headerElement: '.site-header', minWidth: 1024 })}>
      <Filters {theatres} {dates} {times} {hideFilters} />
    </div>
  </div>
  <div class="grow min-w-0">
    <SeminarsList seminars={filtersService.seminars} />
  </div>
</div>